export default {
  START_SELECTION: 'startSelection',
  END_SELECTION: 'endSelection',
  PROCESS_SELECTION: 'processSelection',
  ERROR: 'selectionError'
};
